import { useSubscribe } from "./useSubscribe";
import { useStoreReview } from "./useStoreReview";
import { useSoundConfig } from "./useSoundConfig";

export const useInitialAppConfig = () => {
  useSubscribe();
  useStoreReview();
  const { bgmSound, audioContext } = useSoundConfig();
  return { bgmSound, audioContext };
};
